// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aisles_F23MX {
  display: flex;
  height: 100%;
  width: 100%;
  gap: var(--size-padLarge);
  overflow-x: auto;
  padding: 0 var(--size-padLarge);
}

.content_dBvoz {
  height: 100%;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/aisleHeatmapping/AisleHeatmappingCards.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":[".aisles {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  gap: var(--size-padLarge);\n  overflow-x: auto;\n  padding: 0 var(--size-padLarge);\n}\n\n.content {\n  height: 100%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aisles": `aisles_F23MX`,
	"content": `content_dBvoz`
};
export default ___CSS_LOADER_EXPORT___;
